/* MARMOT Кампания „Време за училище" - браузърната част на обявяването.

   Две задачи, нищо повече:

   1. Таймерът. До 23 септември на мястото му стои изреченият срок (изписан още от
      Liquid, тоест видим и без JavaScript). От 24 септември същото място показва
      брояч с дни, часове и минути, който се опреснява веднъж в минутата.
      Мине ли краят - обявяването се маха от страницата. Това е предпазителят за
      страница, отворена от вчера или сервирана от кеш: Liquid гейтът е верен в
      мига на рендера, но не и после.

   2. Кориците (само блокът на началната). Четат се от СЪЩИЯ източник, който ползва
      попъпът - /api/shopify/checkout/gifts. Празен списък, отказ или мрежова грешка
      значат „без ред корици"; блокът си остава с текста и НЕ изчезва (раздел 13.3).

   Чист vanilla JS със defer, без библиотеки. Логиката на срока е в
   marmot-campaign-school-logic.js, за да е тестима без браузър. */
(function () {
  'use strict';

  var L = window.MarmotCampaignSchool;
  if (!L) return;

  var MINUTA = 60000;

  function apiGet(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (otgovor) {
      if (!otgovor.ok) throw new Error('HTTP ' + otgovor.status);
      return otgovor.json();
    });
  }

  /* Огледало на giftCoverUrl от попъпа: искаме корицата в мярка от CDN-а,
     а не оригинала. */
  function koricaUrl(url, shirina) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + shirina;
  }

  function Kampaniya(root) {
    this.root = root;
    this.end = root.getAttribute('data-end') || '';
    this.countdownFrom = root.getAttribute('data-countdown-from') || '';
    this.timer = root.querySelector('[data-marmot-campaign-timer]');
    this.fine = root.querySelector('[data-marmot-campaign-fine]');
    this.covers = root.querySelector('[data-marmot-campaign-covers]');
    /* Мястото за „избираш от N заглавия" в дребния ред на лентата. Блокът на
       началната го няма - там числото не се обещава. */
    this.count = root.querySelector('[data-marmot-campaign-count]');
    /* Таван на ветрилото. Липсващ атрибут значи „всички" - така блокът на
       началната си остава с 13-те корици, а лентата в каталога иска 4. */
    this.coversMax = L.tavan(root.getAttribute('data-covers-max'));
    this.timeout = null;
  }

  /* Изчезването е тихо и пълно: махаме възела, а не само текста - иначе на
     страницата остава празна светлосиня кутия без съдържание. */
  Kampaniya.prototype.mahni = function () {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.root.parentNode) this.root.parentNode.removeChild(this.root);
  };

  Kampaniya.prototype.tik = function () {
    var now = Date.now();

    if (!L.vSrok(now, this.end)) {
      this.mahni();
      return;
    }

    if (L.sBroyach(now, this.end, this.countdownFrom)) {
      var tekst = L.tekstNaBroyacha(L.ostatak(now, this.end));
      if (tekst && this.timer && this.timer.textContent !== tekst) {
        this.timer.textContent = tekst;
        this.timer.classList.add('is-countdown');
      }
      /* Дребният ред „До 30 септември…" се показва чак сега. Дотогава същото
         изречение стои в мястото на таймера и втори екземпляр под бутона би го
         повторил дума по дума. */
      if (this.fine) this.fine.hidden = false;
    }

    /* Опресняване на кръгла минута, не на всеки 60 000 ms от зареждането:
       иначе броячът прескача минута напред или назад спрямо часовника. */
    var doSledvashta = MINUTA - (now % MINUTA) + 250;
    this.timeout = setTimeout(this.tik.bind(this), doSledvashta);
  };

  Kampaniya.prototype.koriciFetch = function () {
    var self = this;
    if (!this.covers) return;

    var store = this.root.getAttribute('data-store') || '';
    var apiBase = (this.root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    if (!store || !apiBase) return;

    /* Обръщението тръгва и на телефон, където ветрилото е скрито със CSS. Не е
       напразно: същият отговор дава и броя заглавия в дребния ред, а той се
       чете на всяка ширина. */

    apiGet(apiBase + '/api/shopify/checkout/gifts?store=' + encodeURIComponent(store))
      .then(function (otgovor) {
        var gifts = otgovor && Array.isArray(otgovor.gifts) ? otgovor.gifts : [];
        /* Същият филтър като в попъпа: заглавие и картинка са задължителни,
           иначе на екрана излиза дупка вместо корица. */
        /* Показват се ВСИЧКИ налични заглавия, без таван: редът се пренася на
           нов ред и 13 корици по 52-78px се събират. Отрязан списък би обещал
           по-малък избор, отколкото има, и то без нищо на екрана да го казва. */
        var chisti = gifts.filter(function (gift) {
          return gift &&
            typeof gift.title === 'string' && !!gift.title.trim() &&
            typeof gift.image === 'string' && !!gift.image.trim();
        });

        if (!chisti.length) return;

        /* Броят е на ВСИЧКИ налични заглавия, не на показаните корици: текстът
           обещава избора, ветрилото е само мостра. Свърши ли едно заглавие,
           Editera го маха от списъка и числото пада само. */
        self.pishiBroy(chisti.length);

        var zaVetrilo = self.coversMax > 0 ? chisti.slice(0, self.coversMax) : chisti;
        self.risuvajKorici(zaVetrilo);
      })
      .catch(function () {
        /* Мълчи нарочно. Обявяването не зависи от каталога: раздел 13.3 иска
           блокът да остане с текста, а не да се счупи или да изчезне. */
      });
  };

  Kampaniya.prototype.pishiBroy = function (broy) {
    if (!this.count) return;
    var tekst = L.tekstZaBroyZaglavia(broy);
    if (!tekst) return;
    this.count.textContent = tekst;
    this.count.hidden = false;
  };

  Kampaniya.prototype.risuvajKorici = function (gifts) {
    var spisak = document.createElement('ul');
    spisak.className = 'marmot-campaign__covers-list';

    gifts.forEach(function (gift) {
      var red = document.createElement('li');
      red.className = 'marmot-campaign__cover';

      var img = document.createElement('img');
      img.src = koricaUrl(gift.image.trim(), 240);
      /* Мястото се пази от aspect-ratio в CSS-а, а не от тези атрибути: корица с
         друго съотношение иначе мести целия ред, след като се зареди. */
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = gift.title.trim();

      red.appendChild(img);
      spisak.appendChild(red);
    });

    this.covers.innerHTML = '';
    this.covers.appendChild(spisak);
    this.covers.hidden = false;
    this.spisak = spisak;
    this.podredi();
  };

  /* Мери и подава решението на CSS-а.

     Мери се, а не се смята наум, защото на телефон корицата е clamp(52px, 11vw,
     78px) - ширината ѝ зависи от екрана. Зашита стойност би била вярна за една
     ширина и грешна за следващата.

     Мери се от ОБВИВКАТА (полето) и от една корица, а не от списъка: списъкът
     вече носи таван на ширината от предишната сметка и мярка по него би
     потвърдила собственото си ограничение вместо истинското място. Двете мерки
     са с един и същи вид - getBoundingClientRect, тоест и двете дробни: смесени
     с clientWidth (закръглено нагоре) сборът може да излезе с една корица
     повече, таванът да надхвърли полето с частица пиксел и браузърът да пренесе
     сам - точно бъгът, който се поправя.

     Свиването от предишната сметка се маха ПРЕДИ мерене, иначе мерим
     собствения си резултат вместо естествената ширина.

     Решението (кое число и трябва ли свиване) е в podredbaOtMyarka, за да е
     тестимо без браузър. Тук остават само мярката и подаването.

     Ветрилото в каталога НЕ минава оттук: то е нарочно единичен непренасящ се
     ред с нулево отстояние и мярка по него няма смисъл. */
  Kampaniya.prototype.podredi = function () {
    var spisak = this.spisak;
    if (!spisak || !spisak.children.length) return;
    if (!this.root.classList.contains('marmot-campaign--home')) return;

    spisak.style.removeProperty('--marmot-campaign-cover');

    var pole = this.covers.getBoundingClientRect().width;
    var stil = window.getComputedStyle(spisak);
    var otstap = parseFloat(stil.columnGap);
    if (!isFinite(otstap)) otstap = parseFloat(stil.gap);
    var korica = spisak.children[0].getBoundingClientRect().width;

    var reshenie = L.podredbaOtMyarka(spisak.children.length, pole, korica, otstap);
    /* null значи негодна мярка - скрит блок, откачен възел, нулево поле. Тогава
       НЕ се пипа нищо: остава подредбата отпреди, а при първото рисуване -
       подразбирането в CSS-а. Число от негодна мярка е по-лошо от двете. */
    if (!reshenie) return;
    if (reshenie.korica > 0) spisak.style.setProperty('--marmot-campaign-cover', reshenie.korica + 'px');
    spisak.style.setProperty('--marmot-campaign-per-row', String(reshenie.naRed));
  };

  function start() {
    var vsichki = document.querySelectorAll('[data-marmot-campaign]');
    var zhivi = [];
    for (var i = 0; i < vsichki.length; i++) {
      var kampaniya = new Kampaniya(vsichki[i]);
      kampaniya.tik();
      kampaniya.koriciFetch();
      zhivi.push(kampaniya);
    }

    function prepodredi() {
      /* Откачените се изхвърлят, вместо да се обхождат до края на живота на
         страницата: mahni() вади възела от DOM, но обектът оставаше в масива. */
      zhivi = zhivi.filter(function (k) {
        return k.root && k.root.isConnected !== false;
      });
      for (var j = 0; j < zhivi.length; j++) zhivi[j].podredi();
    }

    /* ResizeObserver гледа САМИЯ измерван елемент. Прозорецът не е единственото,
       което мени ширината му: вертикална лента за скролиране, появила се след
       дозареждане на секциите отдолу, стеснява полето, без прозорецът да мръдне,
       и подредбата остава тази от първото рисуване. */
    if (typeof ResizeObserver === 'function') {
      var nablyudatel = new ResizeObserver(function () { prepodredi(); });
      for (var k = 0; k < zhivi.length; k++) {
        if (zhivi[k].covers) nablyudatel.observe(zhivi[k].covers);
      }
      return;
    }

    /* Резерва за браузър без ResizeObserver. Изчаква се 150ms, защото resize се
       обажда на всеки пиксел от влаченето, а сметката пипа разметката. */
    var chasovnik = null;
    window.addEventListener('resize', function () {
      if (chasovnik) clearTimeout(chasovnik);
      chasovnik = setTimeout(prepodredi, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
